/**
 * Status badge components for activity indicators
 */

import { formatTimeAgo } from '../utils/dateHelpers';

interface StatusBadgeProps {
  active: boolean;
  last?: Date | null;
  error: boolean;
  chain: 'steemit' | 'blurt';
}

export function StatusBadge({ active, last, error, chain }: StatusBadgeProps) {
  if (error) {
    return (
      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
        ⚠️ Error
      </span>
    );
  }

  if (!active) {
    return (
      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
        ❌ Inactive
      </span>
    );
  }

  const bgColor = chain === 'steemit' ? 'bg-green-100 text-green-800' : 'bg-blue-100 text-blue-800';

  return (
    <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${bgColor}`}>
      ✅ {last ? formatTimeAgo(last) : 'Active'}
    </span>
  );
}

interface MatchScoreProps {
  score: number;
}

export function MatchScore({ score }: MatchScoreProps) {
  let bgColor = 'bg-red-50 border-red-200 text-red-700';
  let icon = '❌';

  if (score >= 80) {
    bgColor = 'bg-green-50 border-green-200 text-green-700';
    icon = '✅';
  } else if (score >= 50) {
    bgColor = 'bg-yellow-50 border-yellow-200 text-yellow-700';
    icon = '⚠️';
  }

  return (
    <div className={`px-3 py-2 rounded border ${bgColor} text-center font-semibold`}>
      {icon} {score}%
    </div>
  );
}
